import MarketsStream from './markets-stream';
import { wrapPromise } from '../../util/promise-helper';
export default class Stream {
    constructor(option) {
        this.streamInstance = new MarketsStream(option);
        this._status = false;
        this.connect = wrapPromise(async () => {
            await this.streamInstance.connect();
            this._status = true;
            return this.streamInstance;
        });
    }
    setOption(option) {
        this.streamInstance.setOption(option, this._status);
    }
}
